import { render } from "./AddGpsReportForMatch.vue?vue&type=template&id=7f5640e2&scoped=true"
import script from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"
export * from "./AddGpsReportForMatch.vue?vue&type=script&lang=js"

import "./AddGpsReportForMatch.vue?vue&type=style&index=0&id=7f5640e2&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5640e2"]])

export default __exports__